import React from "react";

export const SelectionButton = ({ selected, label, value, onClick}) => {
  return (
    <button
      onClick={onClick}
      value={value}
      className={`py-1.5 px-3 font-light rounded 
      ${ selected 
        ? 'bg-purple-200 text-purple-800 border border-purple-800' 
        : 'bg-gray-100 text-gray-800 border border-white'
      }`}
    >
      {label}
    </button>
  )
}
